import type { Doctrine } from "../models";
import { apiInstance } from "../utils/_apiInstance";

export const getDoctrineById = async (id: string) => {
  const response = await apiInstance.get<Doctrine>(
    `pesquisa/doutrina?id=${id}`,
  );
  return response.data;
};
